export default "__VITE_ASSET__B6SckBQm__"